import { render, staticRenderFns } from "./IconGreat.vue?vue&type=template&id=4f1ead88&scoped=true"
import script from "./IconGreat.vue?vue&type=script&lang=js"
export * from "./IconGreat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ead88",
  null
  
)

export default component.exports